import { render, staticRenderFns } from "./AdminData.vue?vue&type=template&id=bc75ee2e&"
import script from "./AdminData.vue?vue&type=script&lang=js&"
export * from "./AdminData.vue?vue&type=script&lang=js&"
import style0 from "./AdminData.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AdminData.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports